module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"invoices":"Invoices","not-found":"Invoices not found","not-found-description":"We didn\u0027t find any invoice. If you think this is a issue, please contact us."},"pt-BR":{"invoices":"Faturas","not-found":"Nenhuma fatura encontrada","not-found-description":"Não encontramos nenhuma fatura. Se você acha que tem um problema, favor entrar em contato conosco."}}')
  delete Component.options._Ctor
}
